module.exports = __webpack_public_path__ + "logo.jpg?8a307267348a73008c2748bace90f1e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 471
// module chunks = 0